{
  "en": "Anglais",
  "de": "Allemand",
  "fr": "Français",
  "es": "Espagnol",
  "cs": "Tchèque",
  "da": "Danois",
  "et": "Estonien",
  "fi": "Finnois",
  "hr": "Croate",
  "hu": "Hongrois",
  "it": "Italien",
  "lt": "Lituanien",
  "lv": "Letton",
  "nl": "Néerlandais",
  "nb": "Norvégien bokmål",
  "pl": "Polonais",
  "pt": "Portugais",
  "ro": "Roumain",
  "sk": "Slovaque",
  "sl": "Slovène",
  "sq": "Albanais",
  "sv": "Suédois"
}
